export default "__VITE_ASSET__5d649b93__"